<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Учредители</h5>
      <template v-if="founders?.length">
        <p class="mb-2 text-muted">Всего учредителей: {{ founders.length }}</p>
        <ul class="info-list mt-2">
          <li
            v-for="founder in founders.slice(0, 2)"
            :key="founder.id || founder.inn || founder.name || founder.fio"
            class="border-bottom py-2"
          >
            <span class="info-title">{{ founder.fio || founder.name || companyName }}</span>
            <span class="info-value">
              {{ Number(founder.fraction?.percent || 0) }}%
              <template v-if="founder.inn">, ИНН {{ founder.inn }}</template>
            </span>
          </li>
        </ul>
      </template>
      <template v-else>
        <p class="mb-0">Нет данных</p>
      </template>
      <button class="btn-primary btn-small d-block ms-auto mt-2" @click="emitChangeTab('tab-founders')">
        Подробнее
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FoundersInfo',
    props: {
      companyName: String,
      founders: Array,
    },
    setup(_, { emit }) {
      const emitChangeTab = (newTab) => {
        emit('change-tab', newTab);
      };

      return {
        emitChangeTab,
      };
    },
  };
</script>
